import "./util-transport-location.scss";

import { Outlet } from "react-router-dom";

import { FilterUtilTransportLocationProvider } from "./filter-util-transport-location/filter-util-transport-location.context";

export function UtilTransportLocation() {
  return (
    <div id="ShellUtilTransportLocation" className="util-transport-location">
      <FilterUtilTransportLocationProvider>
        <Outlet />
      </FilterUtilTransportLocationProvider>
    </div>
  );
}

export default UtilTransportLocation;
